import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import MainPage from './pages/MainPage';
import SuccessPage from './pages/SuccessPage';
import ErrorPage from './pages/ErrorPage';
import ReturnPage from './pages/ReturnPage';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage/>} />
        <Route path="/return" element={<ReturnPage/>} />
        <Route path="/error" element={<ErrorPage/>} />
      </Routes>
    </Router>
  );
};

export default App;
